<template>
<div>
    <div class="container containerNew">
        <div class="common-header-wrap">
            <mt-header :title="$t('yi2')" class="common-header">
                <mt-button slot="left" icon="back" @click="onPage('index')"></mt-button>
                <!-- <mt-button class="rule" slot="right" @click="onPage('hunt_newRule')">{{ $t('hunt65') }} >></mt-button> -->
            </mt-header>
        </div>
        <!-- 首页页面 -->
        <div class="price">
            <div class="price_body">
                <div v-for="el in UsdList" :key="el" @click="onDesPage(el)">
                    <span>{{ el }}USD</span>
                </div>
            </div>
        </div>
    </div>
    <!-- Des 详情页面 -->
    <!-- <Des class="one_body" v-else :val="usd" @onPage="onGoto" ref="RefDes"/> -->
</div>
</template>

<script>
import Des from './des.vue'
import HuntNewRule from '../hunt/newRule.vue'
import { GetCycleList } from '../../../api/memberOne'

export default {
    name: 'UsdPage',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            default: 'right'
        },
        one: {
            default: false,
            type: Boolean
        },
    },
    components: {
        Des,
        HuntNewRule
    },
    data() {
        return {
            isShow: this.visible,
            page: 'usd_page',
            UsdList: [],
            usd: '',
            isDes: false
        }
    },
    created() {
        this.loadUsdList()
    },
    mounted() {
    },
    methods: {
        onPage(v, val) {
            this.$emit('onPage', 'index');
        },
        // 加载 USD 列表
        loadUsdList() {
            const cached = localStorage.getItem('all_usd_list')
            if (cached) {
                this.UsdList = JSON.parse(cached)
            } else {
                GetCycleList({'all':1}, 'one').then(res => {
                    if (res && res.result) {
                        this.UsdList = res.result
                        localStorage.setItem('all_usd_list', JSON.stringify(res.result))
                    }
                }).catch(() => {})
            }
        },

        // 切换页面（非规则页）
        onDesPage(usdValue = '') {
            this.$emit('onPage','des', usdValue)
        },

        // 切换页面（规则页）
        onPagesWon(view, val = {}, returnPage = 'index') {
            this.isDes = true
            this.page = view
            this.objData = val || {}
            this.objData.page = returnPage
        },

        // 子组件返回处理
        onGoto(view) {
            if (view === 'x') {
                this.isShow = false
                this.$emit('onVisible', false)
                return
            }
            this.isDes = false
            this.page = view
        },

        // 调用子组件方法（备用工具）
        callChildMethod(ref, methodName, payload) {
            const child = this.$refs[ref]
            if (child && typeof child[methodName] === 'function') {
                child[methodName](payload)
            }
        }
    }
}
</script>
<style scoped lang="scss">
.rule{
    text-align: right;
    font-size: 13px;
    color: #716c6c;
    cursor: pointer;
}
.pagex {
    width: 100%;
    height: 100%;
}
.one {
    width: 82%;
    height: 100vh;
    background: rgba(0, 0, 0, 0);
}

.onePc {
    width: 20%;
    min-width: 375px;
    height: 70vh;
    background: rgba(0, 0, 0, 0);
}


.flex {
    display: flex;
}

.pagePc {
    padding: 0 !important;
    overflow-y: hidden !important;
}

.one_body {
    overflow-y: auto;
    width: 100%;
    height: 100vh;
    background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
    border-radius: 12px;
    border: 1px solid #F45C1D;
    padding: 15px 20px;
    box-sizing: border-box;
    position: relative;

    .imge {
        position: absolute;
        left: 0;
        width: 50%;
        bottom: 10%;
        transform: translate(50%, 0%);
    }

    .title {
        align-items: center;
        justify-content: space-between;

        .title_t {
            font-size: 14px;
            color: #000;
            font-weight: bold;
            cursor: pointer;

            div {
                width: 100%;
                height: 5px;
                background: linear-gradient(90deg, #F21D19 0%, #FFF5F4 100%);
                border-radius: 8px;
            }
        }
        .title_x {
            cursor: pointer;

            svg {
                width: 20px;
                height: 20px;
            }
        }
    }
    .title_r {
        text-align: right;
        font-size: 13px;
        color: #716c6c;
        cursor: pointer;
    }
    .price {
        margin: 40px 20px;
        border: #F9A07B 1px solid;
        border-radius: 10px;
        padding: 10px 5px;
        box-sizing: border-box;
        position: sticky;
        z-index: 999;

        .price_title {
            font-size: 16px;
            color: #333;
            font-weight: bold;
            padding-left: 10px;
        }

        .price_body {
            padding: 20px 0 0;
            color: #EC3031;
            font-size: 12px;
            display: grid;
            grid-template-columns: repeat(3, 1fr);


            div {
                margin-bottom: 20px;
                text-align: center;
            }

            span {
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }

    .run {
        border: #F9A07B 1px solid;
        border-radius: 10px;
        padding: 20px 10px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
        gap: 20px;
        font-size: 12px;
        z-index: 10;
        position: sticky;

        div {
            padding: 10px 0;
            text-align: center;
            font-weight: bold;
            cursor: pointer;
            background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
            border-radius: 5px;
            border: 1px solid #F45C1D;
        }
    }
}
</style>